var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 1 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.960938,
    width: 25,
    height: 25,
    rx: 5,
    fill: "url(#paint0_linear_3643:9695)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2344 4.23156C8.45209 4.23156 4.86042 3.89511 3.48854 7.41594C2.92188 8.87011 3.00417 10.7586 3.00417 13.4628C3.00417 15.8357 2.92813 18.0659 3.48854 19.5086C4.85729 23.0316 8.47813 22.6941 12.2323 22.6941C15.8542 22.6941 19.5885 23.0711 20.9771 19.5086C21.5448 18.0399 21.4615 16.1795 21.4615 13.4628C21.4615 9.85657 21.6604 7.52844 19.9115 5.78052C18.1406 4.00969 15.7458 4.23156 12.2302 4.23156H12.2344ZM11.4073 5.89511C19.2969 5.88261 20.301 5.00552 19.7469 17.1899C19.55 21.4993 16.2688 21.0264 12.2354 21.0264C4.88125 21.0264 4.66979 20.8159 4.66979 13.4586C4.66979 6.01594 5.25313 5.89927 11.4073 5.89302V5.89511ZM17.1615 7.4274C16.55 7.4274 16.0542 7.92323 16.0542 8.53469C16.0542 9.14615 16.55 9.64198 17.1615 9.64198C17.7729 9.64198 18.2688 9.14615 18.2688 8.53469C18.2688 7.92323 17.7729 7.4274 17.1615 7.4274ZM12.2344 8.72219C9.61667 8.72219 7.49479 10.8451 7.49479 13.4628C7.49479 16.0805 9.61667 18.2024 12.2344 18.2024C14.8521 18.2024 16.9729 16.0805 16.9729 13.4628C16.9729 10.8451 14.8521 8.72219 12.2344 8.72219ZM12.2344 10.3857C16.3021 10.3857 16.3073 16.5399 12.2344 16.5399C8.16771 16.5399 8.16146 10.3857 12.2344 10.3857Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3643:9695",
    x1: 1.68118,
    y1: 24.3646,
    x2: 24.9117,
    y2: 4.28514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.1a0932d7a78ceea75b4dc8cf3a31e908.svg";
export { ForwardRef as ReactComponent };